import { Icon } from "@circle-react-shared/Icon";
import type { PropsWithChildren } from "react";

export const Arrow = ({ children }: PropsWithChildren<unknown>) => (
  <div className="inline-block">
    <Icon type="16-arrow-right" size={16} className="text-primary" />
    {children}
  </div>
);
